// This module simply returns a javascript object build from the JSON data
// in the page which holds the initialisation data for userMessaging

/* global _IMAGES_URL */

let rawData = {};
if (document.getElementById('user-messaging-data') !== null) {
  const dataJSON = document.getElementById('user-messaging-data').textContent;
  rawData = JSON.parse(dataJSON);
  rawData.userMessaging.emoticonURL = `${_IMAGES_URL}emoticons/`;
}

export const data = rawData;
